import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
import {
  getDateArray,
  formatDate
} from '@/utils'

const defaultFormat = 'yyyy-MM-dd'
const now = new Date()
const threeMonth = new Date()
threeMonth.setMonth(now.getMonth() + 3)
threeMonth.setDate(0)
const defaultDateArray = getDateArray(now)

export default {
  state: {
    value: defaultDateArray,
    schedules: [],
    start: formatDate(new Date(), defaultFormat),
    end: formatDate(threeMonth, defaultFormat)
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/schedules/index.js